import { inlineRuns } from '@ads/shared';

/* Tudo que vem do agente passa por aqui: texto é escapado, links são
   filtrados. O HTML final não contém uma única string não tratada. */

export const esc = (s: string) =>
  s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');

/** Texto com **ênfase** → <strong>, o resto escapado. */
export const rich = (s: string) =>
  inlineRuns(s).map(r => (r.strong ? `<strong>${esc(r.text)}</strong>` : esc(r.text))).join('');

/** Só http(s), mailto, tel, âncoras e caminhos do próprio site. */
export function safeHref(href: string | undefined, fallback = '#contato'): string {
  const h = (href ?? '').trim();
  if (!h) return fallback;
  if (/^(https?:\/\/|mailto:|tel:)/i.test(h)) return h;
  if (/^#[\w-]*$/.test(h)) return h;
  if (/^\/[\w\-/]*$/.test(h)) return h;
  return fallback;
}

export const isExternal = (href: string) => /^https?:\/\//i.test(href);

/** id seguro para âncora */
export const anchor = (s: string) =>
  s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 48) || 'secao';
